define('views/modules/template/assignment/assignment-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/template/assignment/assignment-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VAssignmentContent
) {

    var VTemplateAssignmentPanel = VBasePanel.extend({
        content: {
            assignment: VAssignmentContent,
        },

        header: {
            title: "Assign a template",
            subtitle: "Select a template to assign",
        },

        tabs: [{ id: 'assignment', title: 'Assignmment', active: true }],
        defaultView: 'assignment',

        initialize: function(opt) {
            var assignment = this.getView('assignment', {
                model: this.model,
                group: opt.group,
                profile: opt.profile
            });
            this.listenTo(assignment, { 'form:success': this.close });
        },

    });

    return VTemplateAssignmentPanel;

});

